import { IsEnum, IsUUID } from 'class-validator';
import { BindableQrTargetType } from './qr-target-type.enum';

export class BindQrDto {
  @IsUUID(undefined, { message: 'INVALID_QR_FORMAT' })
  qrUuid!: string;

  @IsEnum(BindableQrTargetType, { message: 'INVALID_TARGET_TYPE' })
  targetType!: BindableQrTargetType;

  @IsUUID(undefined, { message: 'INVALID_TARGET_ID' })
  targetId!: string;
}
